import { render, staticRenderFns } from "./WannasornMemberEditForm.vue?vue&type=template&id=27c46775"
import script from "./WannasornMemberEditForm.vue?vue&type=script&lang=js"
export * from "./WannasornMemberEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports